import "react-toastify/dist/ReactToastify.min.css";
import SellerLayout from "../components/SellerLayout";

const WelcomeSeller = () => {

    return (
        <SellerLayout>
            <div>
                <p>
                    WELCOME SELLERE
                </p>
            </div>
        </SellerLayout>
    );
};

export default WelcomeSeller;
